export default "__VITE_ASSET__6kssa3xCT2YlMpIbbRNP$Q__"